import ItineraryDetils from './ItineraryDetails'

export default ItineraryDetils
